import React from "react"
import type {
    StyleProps,
    TagProps,
    TagVariant,
} from "@mallardbay/lib-react-components"
import { Tag, componentStyles } from "@mallardbay/lib-react-components"

import Image from "~components/shared/todo-lib-react-components/image"
import type { PropsWithChildrenAndStyle } from "~components/shared/todo-lib-react-components/types"

interface Props
    extends PropsWithChildrenAndStyle,
        Pick<TagProps, "colorScheme"> {
    readonly imageSrc: string
    readonly imageAlt: string
    readonly imageStyle?: StyleProps
    readonly variant?: TagVariant
}

export default function ImageTag({
    children,
    style,
    imageSrc,
    imageAlt,
    imageStyle,
    colorScheme,
    variant,
}: Props) {
    const tagStyles = useStyles()
    return (
        <Tag
            style={{ ...tagStyles.tag, ...style }}
            colorScheme={colorScheme}
            variant={variant}
        >
            <Image src={imageSrc} style={imageStyle} alt={imageAlt} />
            {children}
        </Tag>
    )
}

function useStyles() {
    return componentStyles({
        tag: {
            borderRadius: "20px",
            gap: 2,
        },
    })
}
